import {
  EXPIRATION_DATE_FOR_BANK_TRANSFER_ITEM,
  EXPIRATION_DATE_FOR_PENDING_BANK_TRANSFER_ITEM,
  EXPIRATION_DATE_FOR_PENDING_QR_CODE_ITEM,
  EXPIRATION_DATE_FOR_PENDING_USSD_CODE_ITEM,
  EXPIRATION_DATE_FOR_QR_CODE_ITEM,
  EXPIRATION_DATE_FOR_USSD_CODE_ITEM,
} from "@zenith/data/constants";

// Add constant for localStorage key
const TOTAL_AMOUNT_STORAGE_KEY = "qr_code_total_amount";

/**
 * Cleans all the payment info on the local storage.
 * @function
 * @name cleanLocalStorageInfo
 * @kind function
 * @returns {void}
 * @exports
 */
export function cleanLocalStorageInfo(): void {
  localStorage.removeItem(EXPIRATION_DATE_FOR_USSD_CODE_ITEM);
  localStorage.removeItem(EXPIRATION_DATE_FOR_PENDING_USSD_CODE_ITEM);
  localStorage.removeItem(EXPIRATION_DATE_FOR_BANK_TRANSFER_ITEM);
  localStorage.removeItem(EXPIRATION_DATE_FOR_PENDING_BANK_TRANSFER_ITEM);
  localStorage.removeItem(EXPIRATION_DATE_FOR_QR_CODE_ITEM);
  localStorage.removeItem(EXPIRATION_DATE_FOR_PENDING_QR_CODE_ITEM);
  localStorage.removeItem(TOTAL_AMOUNT_STORAGE_KEY);
}
